import { render, staticRenderFns } from "./CoverageDetailScienceGraphics.vue?vue&type=template&id=655c10a8"
import script from "./CoverageDetailScienceGraphics.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageDetailScienceGraphics.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports